// TEMPORARY: standalone old-admin-UI page for the Gmail org toggle. Remove at
// old admin UI retirement — the same toggle already lives in the new settings
// modal at Access → Integrations (settings_modal_integrations_page.js).
// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { PageHeader } from '@calendly/ui/components/page-header';
import { Sheet } from '@calendly/ui/components/sheet';
import { TitleText } from '@calendly/ui/components/typography';
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context';
import { GoogleSyncSection } from '../../settings_modal/settings_modal_integrations_page';
const cardContainerCss = "c1qk0mrk";
export const IntegrationsPage = () => {
  const inSettingsModal = useIsSettingsModalLayout();
  usePageTitle('Integrations');
  return <>
      {!inSettingsModal && <PageHeader eyebrow={<TitleText variant="eyebrow">
              {I18n.t('publisher.admin.navigation.organization')}
            </TitleText>} title={I18n.t('publisher.admin.navigation.integrations')} />}
      <Sheet className={cardContainerCss}>
        <FlexLayout direction="column">
          <GoogleSyncSection />
        </FlexLayout>
      </Sheet>
    </>;
};

require("./integrations.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./integrations.js");